<template>
  <el-container style="height: 100%">
    <el-header height="48px">
      EPS 设备管理平台
      <userInfo class="user" />
    </el-header>

    <el-container style="height: calc(100% - 48px);">
      <el-menu
        :unique-opened="true">
        <menu-tree
          v-for="item in navData"
          :key="item.id"
          :menu="item" />
      </el-menu>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalData from '@/api/global_data'
import userInfo from '@/modules/user/index'
import MenuTree from '@/components/MenuTree'

export default {
  name: 'frame',
  beforeCreate () {
    if (this.$route.path !== '/') {
      this.$router.replace('/')
    }
  },
  data () {
    return {
      navData: [],
      activeRoute: ''
    }
  },
  components: {
    userInfo,
    MenuTree
  },

  computed: {
    ...mapGetters(['isLogined'])
  },

  mounted () {
    this.getRightMenu()
  },

  methods: {
    getRightMenu () {
      const m = GlobalData.getRightMenus(localStorage.user_rights.split(','))
      this.navData = m
      this.handleRoute(this.navData[0])
    },
    handleRoute (menu) {
      // 通过菜单URL跳转至指定路由
      if (this.activeRoute !== menu.url) {
        this.activeRoute = menu.url
        this.$router.push({ name: menu.name, params: { childrenList: menu.children } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-header{
  padding: 0 12px;
  line-height: 48px;
  background: linear-gradient(90deg, #1BC6D7 0%, #5784E7 100%);
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  z-index: 100;
  .user{
    position: absolute;
    right: 20px;
    top: 0;
  }
}

.el-aside{
  overflow-y: auto;
  overflow-x: hidden;
  color: #999999;
  font-weight: 400;
  font-size: 14px;
  padding-top: 20px;
  ul{
    li{
      cursor: pointer;
      padding: 17px 0 17px 17px;
      &:hover{
        background: rgba(113, 186, 194, 0.1);
      }
      &.active{
        background: rgba(27, 197, 215, 0.1);
        color: #1BC5D7;
      }
      i{
        margin-right: 14px;
      }
    }
  }
}

.el-main {
  padding: 25px 24px;
  overflow: auto;
  background-color: #F5F6F6;
}
</style>
